// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip_tooltip__nTTsE","title":"tooltip_title__UisbJ","noColor":"tooltip_noColor__5P5ec","crosshair":"tooltip_crosshair__BIH0A"};